import type { DropdownChipLabelProps } from './DropdownChipLabel';
import type { DropdownFilterProps } from './DropdownFilter';
import type { DropdownInputProps } from './DropdownInput';
import type { DropdownMultiSelectProps } from './DropdownMultiSelect';

export type OldDropdownChipLabelProps<OptionValue> = Omit<
  DropdownChipLabelProps<OptionValue>,
  'allSelected' | 'onChange'
> & {
  /** @deprecated allSelected를 대신 사용해주세요. */
  isAllCheck?: boolean;
  /** @deprecated onChange를 대신 사용해주세요. */
  onOptionValuesChange?: (values: Array<OptionValue>) => void;
};

export function convertOldDropdownChipLabelProps<OptionValue>(
  props: OldDropdownChipLabelProps<OptionValue>,
): DropdownChipLabelProps<OptionValue> {
  const { isAllCheck, onOptionValuesChange, ...restProps } = props;

  return {
    ...restProps,
    allSelected: isAllCheck,
    onChange: onOptionValuesChange,
  };
}

export type OldDropdownFilterProps<OptionValue> = Omit<
  DropdownFilterProps<OptionValue>,
  'leftIcon' | 'variant' | 'hasSelectAll' | 'hasFilter'
> & {
  /** @deprecated leftIcon을 대신 사용해주세요. */
  startIcon?: DropdownFilterProps<OptionValue>['leftIcon'];
  /** @deprecated variant를 대신 사용해주세요. */
  kind?: DropdownFilterProps<OptionValue>['variant'];
  /** @deprecated hasSelectAll을 대신 사용해주세요. */
  allCheck?: boolean;
  /** @deprecated hasFilter를 대신 사용해주세요. */
  showFilter?: boolean;
};

export function convertOldDropdownFilterProps<OptionValue>(
  props: OldDropdownFilterProps<OptionValue>,
): DropdownFilterProps<OptionValue> {
  const { startIcon, kind, allCheck, showFilter, ...restProps } = props;

  return {
    ...restProps,
    leftIcon: startIcon,
    variant: kind,
    hasSelectAll: allCheck,
    hasFilter: showFilter,
  };
}

export type OldDropdownInputProps<OptionValue> = Omit<DropdownInputProps<OptionValue>, 'leftIcon' | 'rightIcon'> & {
  /** @deprecated leftIcon을 대신 사용해주세요. */
  startElement?: DropdownInputProps<OptionValue>['leftIcon'];
  /** @deprecated rightIcon을 대신 사용해주세요. */
  endElement?: DropdownInputProps<OptionValue>['rightIcon'];
};

export function convertOldDropdownInputProps<OptionValue>(
  props: OldDropdownInputProps<OptionValue>,
): DropdownInputProps<OptionValue> {
  const { startElement, endElement, ...restProps } = props;

  return {
    ...restProps,
    leftIcon: startElement,
    rightIcon: endElement,
  };
}

export type OldDropdownMultiSelectProps<OptionValue> = Omit<DropdownMultiSelectProps<OptionValue>, 'hasSelectAll'> & {
  /** @deprecated hasSelectAll을 대신 사용해주세요. */
  allCheck?: boolean;
};

export function convertOldDropdownMultiSelectProps<OptionValue>(
  props: OldDropdownMultiSelectProps<OptionValue>,
): DropdownMultiSelectProps<OptionValue> {
  const { allCheck, ...restProps } = props;

  return {
    ...restProps,
    hasSelectAll: allCheck,
  };
}
